import {
    CONTACTOS_CURRENT,
    CONTACTOS_CONTRATO,
    CONTACTOS_CREAR_CONTRATO,
} from '../actions/contactos';

/**
 * current: Contacto usado en el formulario para usar en el WIZARD
 */
const initialState = {
    esHabilitadoCrearContrato: true,
    current: null,
    contrato: null,
};

const reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case CONTACTOS_CURRENT:
            return {
                ...state,
                current: payload,
            };
        case CONTACTOS_CONTRATO:
            return {
                ...state,
                contrato: payload,
            };
        case CONTACTOS_CREAR_CONTRATO:
            return {
                ...state,
                esHabilitadoCrearContrato: payload,
            };
        default:
            return {
                ...state
            };
    }
};

export default reducer;
